<template>
    <div class="admin-layout-wrapper">
        <EonTabMenu :leftItems="menuLeftItems" :rightItems="menuRightItems"/>
        <router-view/>
    </div>
</template>

<script>
    import EonTabMenu from "@/components/form/EonTabMenu";

    export default {
        name: "layoutAccepter",
        components: {EonTabMenu},
        data() {
            return {
                myHeight: "",
                menuLeftItems: [
                    {
                        label: "Planowane wyłączenia",
                        to: "/accepter/planned",
                    },
                    {
                        label: "Generowanie raportu",
                        to: "/accepter/report",
                    },
                ],
                menuRightItems:
                    [
                        {
                            icon: "pi pi-user",
                            label: "Moje konto",
                            to: "/accepter/user",
                        },
                        {
                            label: "Wyloguj",
                            icon: "pi pi-sign-out",
                            to: "/login",
                            onClick: this.logout,
                        },
                    ],
            };
        },
        methods: {
            logout() {
                localStorage.removeItem("token");
                localStorage.removeItem("userId");
                localStorage.removeItem("role");
                localStorage.removeItem("fullName");
                localStorage.removeItem("area");
                localStorage.removeItem("email");
                localStorage.removeItem("phone");
            },
        },
        mounted() {
            if (!localStorage.getItem("token")) {
                this.$router.push({name: "login"});
            }
        },
    };
</script>

<style lang="less" scoped>
@import "../assets/less/layout-admin.less";
</style>
